import { Predicate } from "@siteimprove/alfa-predicate";
const { equals } = Predicate;
export function hasValue(valueOrPredicate, ...values) {
    let predicate;
    if (typeof valueOrPredicate === "function") {
        predicate = valueOrPredicate;
    }
    else {
        predicate = equals(valueOrPredicate, ...values);
    }
    return (name) => predicate(name.value);
}
//# sourceMappingURL=has-value.js.map